export default function userAuth(state = {}, {type, payload}) {
    switch (type) {
        case 'USER_SELECTED_QUERIES': {
            return {
                ...state,
                ...payload,
            };
        }

        default:
            return state;
    }
}
